import { useMediaQuery } from '@mantine/hooks';

export const useIsMobile = (breakpoint = 500) => {
  return !useMediaQuery(`(min-width: ${breakpoint}px)`);
};
